<template>
    <div>
  
      <el-row style="margin-bottom:10px;">
        <el-col :span="18" class='flex'>
          <el-input
            v-model="getQuestionTopicGroupList_data.qtgName"
            placeholder="请输入题目分组名"
            clearable
            size='small'
            style="max-width:380px;"/>
          <el-button
            v-click.getQuestionTopicGroupList
            type="primary"
            icon='el-icon-search'
            size='small'
            style='margin-left:10px;'
          >搜索
          </el-button>
        </el-col>
        <el-col :span="6" >
          <el-button
            v-if='addQuestionTopicGroup'
            @click=" $form('addQuestionTopicGroup') "
            size='small'
            type="primary"
            style="float:right"
            icon='el-icon-circle-plus'
          >添加题目分组
          </el-button>
        </el-col>
      </el-row>
  
      <mytable
        :tableColums='tableColums_getQuestionTopicGroupList'
        api='getQuestionTopicGroupList'
        updateapi='updateQuestionTopicGroup'
        :height="H-165" >
      </mytable> 
  
      <myform
        :viewobj='{
          addQuestionTopicGroup:    [ "新增题目分组信息", "el-icon-circle-plus" ],
          updateQuestionTopicGroup: [ "修改题目分组信息", "el-icon-edit-outline"],
          $succeed$: getQuestionTopicGroupList
        }'
        @close='$form("addQuestionTopicGroup","reset")' >
        <!-- <hide slot='vtId' /> -->
      </myform>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        vtId: null,
        tableColums_getQuestionTopicGroupList: {
          $selection: false,
          qtgName: '题目分组名称',
          // ycDelete: ['状态',,'@v-if: 1:正常 🔍#(--Themecolor),  3:弃用 🖊#warn, 2:已删除 ❌#danger+'],
  
          $operation: [
            '操作', 200,
            this.updateQuestionTopicGroup && `@text: 编辑#success
             @click: $form("updateQuestionTopicGroup",$row)
            `,
            this.deleteAjMobileCard && `@text: 删除#danger
             @click: _confirm('确定要删除该题目分组吗?')
                     .trigger('deleteAjMobileCard',{qtgId:$row.qtgId})
                     .trigger('getQuestionTopicGroupList')
            `,
          ],
  
        },
  
      };
    },
  
    watch: {
      
    },
  
    methods: {},
  
    created() {
      this.getQuestionTopicGroupList();
    }
  };
  </script>
  
  <style scoped>
  </style>
  


// WEBPACK FOOTER //
// src/views/paper/group.vue